module.exports = __webpack_public_path__ + "img/WAREHOUSING.33f6bcae.svg";